var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4589C0.278667 9.78162 0.66 8.99663 1.144 8.1039C1.628 7.19577 2.17067 6.26455 2.772 5.31024C3.388 4.35594 4.04067 3.41703 4.73 2.49351C5.434 1.56998 6.138 0.738816 6.842 0H8.8V10.1587H10.604V11.9134H8.8V16H6.82V11.9134H0V10.4589ZM6.82 2.53968C6.38 3.03223 5.93267 3.58634 5.478 4.20202C5.038 4.80231 4.60533 5.43338 4.18 6.09524C3.75467 6.75709 3.35133 7.43434 2.97 8.12698C2.60333 8.81962 2.27333 9.49687 1.98 10.1587H6.82V2.53968Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.3fbe92191ee420c5eaabe9200adf224e.svg";
export { ForwardRef as ReactComponent };